import About from "./Components/About";
import Hero from "./Components/Hero";
import Navbar from "./Components/Navbar";
import Support from "./Components/Support";
import AllInOne from "./Components/AllInOne";
import Pricing from "./Components/Pricing";
import Footer from "./Components/Footer";


function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Support />
      <AllInOne />
      <Pricing />
      <Footer />
    </>
  );
}

export default App;
